// @ts-nocheck
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from "../../stores/mobx-compat";

import useLoginStore from '../../stores/loginStore';
import AuthShell from './AuthShell';
import { Field, PrimaryButton, MailIcon } from '../../components/ui';

const ForgotPasswordPage = ({ store }) => {
  const {
    email, loading, error,
    setField, setLoading, setError,
  } = useLoginStore();
  const [sentTo, setSentTo] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await store.auth.sendCustomPasswordResetEmail(email.trim());
      setSentTo(email.trim());
      store.success(`Reset email sent to ${email}`);
    } catch (err) {
      setError('We couldn’t send the reset email. Double-check the address and try once more.');
    } finally {
      setLoading(false);
    }
  };

  if (sentTo) {
    return (
      <AuthShell
    eyebrow="Check your inbox"
        headline={(<>A link is on its <em>way.</em></>)}
        lede={(
          <>
            We sent a password reset link to{' '}
            <span className="mono text-[14px] text-mov-ink">{sentTo}</span>. The link expires in 60 minutes — open it on the device you plan to sign in from.
          </>
        )}
      >
        <div className="border border-mov-line-strong rounded-md2 overflow-hidden bg-mov-paper">
          <div className="px-4 py-3.5 border-b border-mov-line flex items-baseline gap-3">
            <span className="mono text-[10.5px] uppercase tabular-nums text-mov-green-ink" style={{ letterSpacing: '0.14em' }}>01</span>
            <span className="mono text-[10.5px] uppercase text-mov-ink" style={{ letterSpacing: '0.14em' }}>Sent</span>
            <span className="mono text-[10.5px] uppercase text-mov-ink-mute ml-auto tabular-nums" style={{ letterSpacing: '0.14em' }}>
              {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </span>
          </div>
          <div className="px-4 py-3.5 border-b border-mov-line flex items-baseline gap-3">
            <span className="mono text-[10.5px] uppercase tabular-nums text-mov-ink-mute" style={{ letterSpacing: '0.14em' }}>02</span>
            <span className="mono text-[10.5px] uppercase text-mov-ink-soft" style={{ letterSpacing: '0.14em' }}>Awaiting open</span>
            <span className="ml-auto inline-flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-mov-ink-mute animate-ping2" style={{ boxShadow: '0 0 0 3px #e6e3db' }} />
              <span className="mono text-[10.5px] text-mov-ink-mute">—</span>
            </span>
          </div>
          <div className="px-4 py-3.5 flex items-baseline gap-3">
            <span className="mono text-[10.5px] uppercase tabular-nums text-mov-ink-mute" style={{ letterSpacing: '0.14em' }}>03</span>
            <span className="mono text-[10.5px] uppercase text-mov-ink-soft" style={{ letterSpacing: '0.14em' }}>Awaiting reset</span>
            <span className="mono text-[10.5px] uppercase text-mov-ink-mute ml-auto" style={{ letterSpacing: '0.14em' }}>—</span>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-2.5">
          <button
            type="button"
            onClick={() => { setSentTo(''); }}
            className="bg-transparent border border-mov-line-strong rounded-sm2 px-4 py-3 text-[13.5px] font-medium text-mov-ink hover:border-mov-ink-mute cursor-pointer"
          >
            Send to another address
          </button>
          <Link
            to="/login"
            className="border border-mov-ink rounded-sm2 px-4 py-3 text-[13.5px] font-medium text-mov-paper bg-mov-ink hover:bg-black no-underline text-center"
          >
            Back to sign in
          </Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell
eyebrow="Reset password"
      headline={(<>Forgot your <em>password?</em></>)}
      lede="Enter the email tied to your account. We'll send you a link to set a new password — valid for 60 minutes."
    >
      <form onSubmit={onSubmit} autoComplete="on" noValidate>
        <Field
          label="Account email"
          name="email"
          type="email"
          value={email}
          onChange={setField}
          autoComplete="email"
          placeholder="you@company.com"
          icon={MailIcon}
        />

        {error && (
          <p className="text-[13px] mb-4 text-accent-red flex items-baseline gap-2">
            <span className="mono uppercase text-[10.5px]" style={{ letterSpacing: '0.14em' }}>Err</span>
            <span>{error}</span>
          </p>
        )}

        <PrimaryButton loading={loading}>Send reset link</PrimaryButton>

        <p className="mt-7 text-center text-mov-ink-soft text-[13.5px]">
          Remembered it?{' '}
          <Link
            to="/login"
            className="text-mov-ink font-medium no-underline border-b border-mov-line-strong pb-px hover:border-mov-green hover:text-mov-green-ink"
          >
            Back to sign in
          </Link>
        </p>
      </form>
    </AuthShell>
  );
};

export default inject('store')(observer(ForgotPasswordPage));
